import { tv, type VariantProps } from 'tailwind-variants'

export const badgeVariants = tv({
  slots: {
    base: 'relative web:inline-flex shrink-0 no-wrap native:p-0',
    bubble: 'absolute',
  },
  variants: {
    placement: {
      'top-right': {},
      'bottom-right': {},
    },
    shape: {
      circle: {},
      rectangle: {},
    },
  },
  defaultVariants: {
    shape: 'rectangle',
    placement: 'top-right',
  },
  compoundVariants: [
    // placement / rectangle
    {
      placement: 'top-right',
      shape: 'rectangle',
      class: {
        bubble: 'native:top[2%] web:top-[5%] right-[5%] -translate-y-1/2 translate-x-1/2',
      },
    },
    {
      placement: 'bottom-right',
      shape: 'rectangle',
      class: {
        bubble: 'native:bottom[2%] right-[5%] translate-x-1/2 translate-y-1/2 web:bottom-[5%]',
      },
    },
    // placement / circle
    {
      placement: 'top-right',
      shape: 'circle',
      class: {
        bubble: 'native:top-[5%] right-[10%] -translate-y-1/2 translate-x-1/2 web:top-[10%]',
      },
    },
    {
      placement: 'bottom-right',
      shape: 'circle',
      class: {
        bubble: 'native:bottom-[5%] right-[10%] translate-x-1/2 translate-y-1/2 web:bottom-[10%]',
      },
    },
  ],
})

export type TBadgeVariantProps = VariantProps<typeof badgeVariants>
export type TBadgeSlots = keyof ReturnType<typeof badgeVariants>
